import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const PageHeader = ({ kicker, title, accent, intro }) => (
  <section className="pt-36 pb-12 lg:pt-44 lg:pb-16">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="text-refocc-orange uppercase tracking-[0.22em] text-xs mb-5">{kicker}</div>
      <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-refocc-dark">
        {title} {accent && <em className="italic text-refocc-orange font-normal">{accent}</em>}
      </h1>
      {intro && <p className="mt-6 text-lg text-refocc-dark/70 max-w-2xl mx-auto leading-relaxed">{intro}</p>}
    </div>
  </section>
);

export const InfoBlock = ({ title, children, img, reverse }) => (
  <section className="py-16">
    <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center ${reverse ? 'lg:[&>*:first-child]:order-2' : ''}`}>
      {img && <div className="rounded-[2rem] overflow-hidden"><img src={img} alt={title} className="w-full aspect-[4/3] object-cover" /></div>}
      <div>
        <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark mb-5">{title}</h2>
        <div className="text-refocc-dark/70 leading-relaxed space-y-4">{children}</div>
      </div>
    </div>
  </section>
);

export const CTASmall = ({ to = '/contact', label = 'Contact Us' }) => (
  <Link to={to} className="inline-flex items-center gap-2 bg-refocc-orange text-white px-6 py-3 rounded-full font-medium hover:bg-[#B97651] transition-colors">{label} <ArrowRight size={16}/></Link>
);
